import dayjs from "dayjs";

// Formats an ISO timestamp the same way the eSIM screens render dates (sq-AL, dd/MM/yyyy HH:mm).
// Returns an em dash when the value is missing or unparseable.
export const formatDateTimeSq = (value?: string | null): string => {
  if (!value) return "—";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "—";
  return date.toLocaleString("sq-AL", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit"
  });
};

// Formats a UTC timestamp (broadcast *AtUtc columns) in the app's display
// timezone (Europe/Belgrade, dayjs default). Returns an em dash when missing.
export const formatUtcDateTime = (value?: string | null): string =>
  value ? dayjs.utc(value).tz().format("DD.MM.YYYY HH:mm") : "—";

// BaseModel timestamps (InsertDate/UpdateDate) are stored in CET, not UTC —
// format them as-is instead of converting.
export const formatCetDateTime = (value?: string | null): string =>
  value ? dayjs(value).format("DD.MM.YYYY HH:mm") : "—";

// Formats a byte count as MB (or GB once it crosses 1024 MB). Returns "0 MB" for none.
export const formatDataSize = (bytes?: number | null): string => {
  if (!bytes || bytes <= 0) return "0 MB";
  const mb = bytes / (1024 * 1024);
  if (mb >= 1024) return `${(mb / 1024).toFixed(2)} GB`;
  return `${mb.toFixed(2)} MB`;
};
